import { useEffect } from 'react'

const SUFIXO = 'Paroquia de Pacaembu'

/**
 * Define o titulo da aba durante a navegacao no SPA.
 *
 * O <title> da primeira carga vem injetado pelo servidor (para o crawler). A
 * partir da primeira navegacao no cliente, e este hook que mantem o titulo
 * correto - sem ele, o titulo congelaria na primeira pagina aberta.
 */
export function useDocumentTitle(titulo: string | null | undefined): void {
  useEffect(() => {
    if (!titulo) return
    const anterior = document.title
    document.title = titulo === SUFIXO ? titulo : `${titulo} - ${SUFIXO}`
    return () => {
      document.title = anterior
    }
  }, [titulo])
}
